module.exports = __webpack_public_path__ + "img/Icon metro-palette.aa42f37a.svg";